module.exports = __webpack_public_path__ + "static/media/pridefit_02.0aab995c.jpg";